import { useEffect, useState } from 'react'
import { isIos, isStandalone, promptInstall, subscribeInstall, subscribePwa } from './register'

const DISMISS_KEY = 'bp.install.dismissed'

function dismissed(): boolean {
  try {
    const v = localStorage.getItem(DISMISS_KEY)
    return v ? Date.now() - Number(v) < 14 * 86400 * 1000 : false
  } catch {
    return false
  }
}

export function InstallBanner() {
  const [available, setAvailable] = useState(false)
  const [hidden, setHidden] = useState(dismissed())
  const [needRefresh, setNeedRefresh] = useState(false)
  const [update, setUpdate] = useState<() => Promise<void>>(() => async () => {})
  const [showIos, setShowIos] = useState(false)

  useEffect(() => subscribeInstall(setAvailable), [])
  useEffect(
    () =>
      subscribePwa((s) => {
        setNeedRefresh(s.needRefresh)
        setUpdate(() => s.update)
      }),
    [],
  )
  useEffect(() => {
    if (isIos() && !isStandalone() && !dismissed()) setShowIos(true)
  }, [])

  const dismiss = () => {
    setHidden(true)
    setShowIos(false)
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()))
    } catch {
      /* ignore */
    }
  }

  if (needRefresh) {
    return (
      <div className="install-banner" role="status">
        <div style={{ flex: 1 }}>
          <strong>Update available</strong>
          <div className="small muted">Reload to get the latest BTown Pride.</div>
        </div>
        <button type="button" className="btn btn--sm" onClick={() => update()}>
          Reload
        </button>
      </div>
    )
  }

  if (hidden || isStandalone()) return null

  if (available) {
    return (
      <aside className="install-banner" aria-label="Install app">
        <div style={{ flex: 1 }}>
          <strong>Install BTown Pride</strong>
          <div className="small muted">
            Map, schedule and tickets on your home screen — works offline.
          </div>
        </div>
        <button
          type="button"
          className="btn btn--sm"
          onClick={async () => {
            const r = await promptInstall()
            if (r !== 'unavailable') dismiss()
          }}
        >
          Install
        </button>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={dismiss}
          aria-label="Dismiss"
        >
          ✕
        </button>
      </aside>
    )
  }

  if (showIos) {
    return (
      <aside className="install-banner" aria-label="Install app">
        <div style={{ flex: 1 }} className="small">
          <strong>Add BTown Pride to your home screen:</strong> tap{' '}
          <span aria-hidden="true">⎋</span> Share, then <em>Add to Home Screen</em>.
        </div>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={dismiss}
          aria-label="Dismiss"
        >
          ✕
        </button>
      </aside>
    )
  }
  return null
}
